import { render } from "./App.vue?vue&type=template&id=4ddd7a1e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ddd7a1e&lang=sass"
script.render = render

export default script